import { StatementType } from './statement-types';

export const FrenchStatements: Record<StatementType, string[]> = {
  annoyed: [
    "Ce n'est pas comme si je ne t'en avais pas parlé hier ?",
    "Ne crois pas que je n'ai pas fait attention !",
    'Je ne peux pas réfléchir avec tout ce vacarme !',
    'Passif-agressif, vraiment ?',
    'Tu sais que ça ne va pas là !',
    "Ça fait 7 heures et 15 jours que tu m'as emprunté ma tondeuse !",
    'Tu es obligé de mâcher si fort ?',
    'Prends-le juste, allez !',
    "Si tu n'as rien de bon à dire, ne dis rien du tout !",
    'Allons-y déjà.',
  ],
  frustrated: [
    'Très bien, fais comme tu veux alors !',
    "Je n'y arriverai jamais !",
    'Le site ne se charge pas !',
    "Cette boîte ne s'ouvre pas !",
    "Tu ne peux pas l'ouvrir comme ça !",
    'Tu dois toujours avoir le dernier mot !',
  ],
  angry: [
    "PUTAIN MAIS QU'EST-CE QUE TU FOUTS !?",
    "Fils bâtard d'une vipère sombre !",
    'Je vais te tuer !',
    'Non, tu as tort !',
    'Tu étais censé nous protéger !',
  ],
  random: [
    'Les oies arrivent ! Les oies arrivent !',
    'Les patates douces ne sont ni sucrées ni des pommes de terre.',
    'Très bien alors ! Yalla !',
    'Les miracles ne cesseront-ils jamais ?',
    '"Waouh, ça fait beaucoup de myrtilles !"',
    'Nom d un chien !',
    'Es-tu sûr de vouloir faire ça ?',
    'Seigneur, aie pitié !',
    "Le ciel est si bleu aujourd'hui.",
    "Je n'ai pas peur des fantômes !",
    'Je suppose que tu ne sais pas cuisiner ?',
    'Calmons-nous tous et respirons profondément.',
    "L'amour est la réponse.",
  ],
  child: [
    'Haha !',
    'Pas assez vite !',
    'Oh là là !',
    'VIEUX !',
    'hahaha',
    'Wouhou !',
    'Tu veux abandonner déjà ?',
    'Regarde ça !',
    'Tu es fatigué ?',
    'Pardon !',
    'Attention !',
  ],
  'child-no': ['Non !'],
  'stay-near-me': ['Reste près de moi, ne t’éloigne pas.'],
};
